import InforDirection from "./InforDirection";

const InforDirectionContainer = () => {
  return <InforDirection />;
};

export default InforDirectionContainer;
